// extracted by mini-css-extract-plugin
export var addressFields = "_jf-0";
export var animationContainer = "_jf-1";
export var footer = "_jf-2";
export var lineItems = "_jf-3";
export var modalContent = "_jf-4";
export var orderName = "_jf-5";
export var strong = "_jf-6";
export var warning = "_jf-7";